/* unplugin-vue-components disabled */import script from "./dict-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./dict-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./dict-dialog.vue?vue&type=style&index=0&id=4b14a9fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b14a9fd"]])

export default __exports__